<template>
  <div 
    v-if="!loading"
    class="glaxi-footer">
    <div class="glaxi-footer__logo">
      <img 
        :src="logo"
        alt="footer logo Glaxi"
        width="199"
        height="62">
    </div>
    <div class="glaxi-footer__links">
      <ul class="glaxi-footer__links__ul--regular">
          <li><router-link :to="{ name: `${lang}.single-page`, params: { slug: 'privacy-policy' } }" class="underline_link">Privacy Policy</router-link></li>
          <li><router-link :to="{ name: `${lang}.single-page`, params: { slug: 'cookie-policy' } }" class="underline_link">Cookie Policy</router-link></li>
      </ul>
      <ul class="glaxi-footer__links__ul--social">
          <li class="c-footer_social_item">
            <a href="https://www.facebook.com/glaxipane/" target="_blank" rel="noopener noreferrer" class="c-follow-us-icon">
              <svg class="c-facebook" width="90px" height="90px" viewBox="0 0 90 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Glaxi-Accademy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-448.000000, -377.000000)">
                    <g id="Group" transform="translate(449.999700, 378.999800)">
                        <path d="M42.719,85.438 L42.719,85.438 C19.126,85.438 -8.5975671e-13,66.312 -8.5975671e-13,42.719 C-8.5975671e-13,19.126 19.126,5.68434189e-14 42.719,5.68434189e-14 C66.312,5.68434189e-14 85.438,19.126 85.438,42.719 C85.438,66.312 66.312,85.438 42.719,85.438 Z" id="Stroke-1" stroke="#000000" stroke-width="4"></path>
                        <path d="M52.1101,44.6367 L45.3651,44.6367 L45.3651,66.3417 L35.3661,66.3417 L35.3661,44.6367 L30.6111,44.6367 L30.6111,36.1397 L35.3661,36.1397 L35.3661,30.6407 C35.3661,26.7097 37.2341,20.5517 45.4541,20.5517 L52.8601,20.5837 L52.8601,28.8307 L47.4861,28.8307 C46.6051,28.8307 45.3651,29.2717 45.3651,31.1467 L45.3651,36.1477 L52.9831,36.1477 L52.1101,44.6367 Z" id="Fill-3" fill="#000000"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <span class="c-circle_bg"></span>
            </a>
          </li>
          <li class="c-footer_social_item">
            <a href="https://www.instagram.com/glaxipanesrl/" target="_blank" rel="noopener noreferrer" class="c-follow-us-icon">
              <svg class="c-instagram" width="91px" height="91px" viewBox="0 0 91 91" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Glaxi-Accademy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Artboard" transform="translate(-675.000000, -602.000000)">
                        <g id="Group-14" transform="translate(677.828300, 604.870400)">
                            <g id="Group-13">
                                <path d="M42.719,85.438 L42.719,85.438 C19.126,85.438 9.66338121e-13,66.312 9.66338121e-13,42.719 C9.66338121e-13,19.125 19.126,4.97379915e-14 42.719,4.97379915e-14 C66.312,4.97379915e-14 85.438,19.125 85.438,42.719 C85.438,66.312 66.312,85.438 42.719,85.438 Z" id="Stroke-9" stroke="#000000" stroke-width="4"></path>
                                <path d="M62.0852,53.0952 C62.0852,58.0962 58.0312,62.1502 53.0302,62.1502 L32.4062,62.1502 C27.4052,62.1502 23.3522,58.0962 23.3522,53.0952 L23.3522,32.4712 C23.3522,27.4702 27.4052,23.4162 32.4062,23.4162 L53.0302,23.4162 C58.0312,23.4162 62.0852,27.4702 62.0852,32.4712 L62.0852,53.0952 Z M53.0832,19.6832 L32.3542,19.6832 C25.3202,19.6832 19.6182,25.3852 19.6182,32.4182 L19.6182,53.1482 C19.6182,60.1822 25.3202,65.8832 32.3542,65.8832 L53.0832,65.8832 C60.1162,65.8832 65.8182,60.1822 65.8182,53.1482 L65.8182,32.4182 C65.8182,25.3852 60.1162,19.6832 53.0832,19.6832 L53.0832,19.6832 Z" id="Fill-11" stroke="#000000" fill="#000000"></path>
                                <path d="M42.718,50.7241 C38.332,50.7241 34.778,47.1691 34.778,42.7841 C34.778,38.3981 38.332,34.8421 42.718,34.8421 C47.104,34.8421 50.659,38.3981 50.659,42.7841 C50.659,47.1691 47.104,50.7241 42.718,50.7241 M42.718,30.6081 C35.994,30.6081 30.543,36.0591 30.543,42.7841 C30.543,49.5071 35.994,54.9581 42.718,54.9581 C49.443,54.9581 54.894,49.5071 54.894,42.7841 C54.894,36.0591 49.443,30.6081 42.718,30.6081" id="Fill-13" stroke="#000000" fill="#000000"></path>
                                <path d="M58.0383,30.2036 C58.0383,31.7116 56.8153,32.9336 55.3083,32.9336 C53.7993,32.9336 52.5763,31.7116 52.5763,30.2036 C52.5763,28.6946 53.7993,27.4726 55.3083,27.4726 C56.8153,27.4726 58.0383,28.6946 58.0383,30.2036" id="Fill-15" fill="#000000"></path>
                            </g>
                        </g>
                    </g>
                </g>
              </svg>
              <span class="c-circle_bg"></span>
            </a>
          </li>
          <li class="c-footer_social_item">
            <a href="https://www.youtube.com/channel/UCt54BsNxeuxuFlHu5-eKkxA" target="_blank" rel="noopener noreferrer" class="c-follow-us-icon">
              <svg class="c-youtube" width="91px" height="90px" viewBox="0 0 91 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Glaxi-Accademy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-562.000000, -377.000000)">
                    <g id="Group-2" transform="translate(564.813100, 378.999800)">
                        <path d="M42.719,85.438 L42.719,85.438 C19.126,85.438 9.66338121e-13,66.313 9.66338121e-13,42.72 L9.66338121e-13,42.719 C9.66338121e-13,19.126 19.126,5.68434189e-14 42.719,5.68434189e-14 C66.312,5.68434189e-14 85.438,19.126 85.438,42.719 C85.438,66.312 66.312,85.438 42.719,85.438 Z" id="Stroke-27" stroke="#000000" stroke-width="4"></path>
                        <path d="M38.0706,50.9922 L38.0706,34.1962 L50.8086,42.5932 L38.0706,50.9922 Z M64.8316,34.5062 C64.8316,30.8222 61.8486,27.8372 58.1656,27.8372 L26.8966,27.8372 C23.2126,27.8372 20.2296,30.8222 20.2296,34.5062 L20.2296,52.3882 C20.2296,56.0712 23.2126,59.0572 26.8966,59.0572 L58.1656,59.0572 C61.8486,59.0572 64.8316,56.0712 64.8316,52.3882 L64.8316,34.5062 Z" id="Fill-29" fill="#000000"></path>
                    </g>
                  </g>
                </g>
              </svg> 
              <span class="c-circle_bg"></span>
            </a>
          </li>
          <li class="c-footer_social_item">
            <a href="https://www.linkedin.com/company/glaxi-pane-s.r.l." target="_blank" rel="noopener noreferrer" class="c-follow-us-icon">
              <svg class="c-linkedin" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                      <polygon id="path-1" points="0 0 18 0 18 18 0 18"></polygon>
                  </defs>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Group" transform="translate(1.000000, 1.000000)">
                          <circle id="Oval" stroke-width="2" cx="19" cy="19" r="19"></circle>
                          <g id="Group-3" transform="translate(10.000000, 9.000000)">
                              <mask id="mask-2" fill="white">
                                  <use xlink:href="#path-1"></use>
                              </mask>
                              <g id="Clip-2"></g>
                              <path d="M18,18 L14.2211835,18 L14.2211835,11.4492026 C14.2211835,9.51638344 13.398844,8.9204759 12.3378848,8.9204759 C11.2168778,8.9204759 10.1173413,9.76350108 10.1173413,11.4973356 L10.1173413,18 L6.33835024,18 L6.33835024,6.00633635 L9.97263329,6.00633635 L9.97263329,7.6679714 L10.0208111,7.6679714 C10.3865087,6.9295832 11.6628717,5.66905652 13.6126767,5.66905652 C15.721329,5.66905652 18,6.91859631 18,10.582111 L18,18 Z M2.17882426,4.33510958 C0.975426211,4.33510958 0,3.42005929 0,2.16807797 C0,0.915922259 0.975426211,0 2.17882426,0 C3.38204775,0 4.35747396,0.915922259 4.35747396,2.16807797 C4.35747396,3.42005929 3.38204775,4.33510958 2.17882426,4.33510958 Z M0.289416009,17.9907571 L4.06823251,17.9907571 L4.06823251,5.99691902 L0.289416009,5.99691902 L0.289416009,17.9907571 Z" id="Fill-1" fill="#1A1919" mask="url(#mask-2)"></path>
                          </g>
                      </g>
                  </g>
              </svg>
              <span class="c-circle_bg"></span>
            </a>
          </li>
      </ul>
      <ul class="glaxi-footer__links__ul--regular">
          <li>
            <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Contacts') } }">
              {{ $t('menu.contacts') }}
            </router-link>
          </li>
          <li><a href="https://goo.gl/maps/tgyUu3uQyfE2" class="underline_link" target="_blank" rel="noopener noreferrer">Google Maps</a></li>
      </ul>

      <GlaxiFooterNewsletter />

    </div>

    <div class="glaxi-footer__coopiright">
      <p>Antico Forno della Romagna. Via I. Golfarelli 78, 47122 Forlì (FC) | CF/P.IVA: 04377760402</p>
    </div>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import GlaxiFooterNewsletter from '@/components/GlaxiFooter/GlaxiFooterNewsletter/GlaxiFooterNewsletter.vue'

import getSinglePages from '@/mixins/getSinglePages.js'

export default {
  name: 'GlaxiFooter',
  mixins: [getSinglePages],
  components: {
    GlaxiFooterNewsletter
  },
  data: () => ({
    logo: require('@/assets/footer/logo-glaxi.svg')
  }),
  computed: {
    currentYear: {
      get () {
        return new Date().getFullYear()
      }
    },
    ...mapGetters([
      'lang'
    ])
  }
}
</script>


<style lang="scss">
  @import "./component.scss";
  @import "./text.scss";
  @import "./social.scss";
</style>
